import api from 'api';
import { useDispatch, useReduxState } from 'hooks';
import { ModalButtonWithForm, User } from 'components/common';
import { EmailMessageEditor, FormGroup } from 'components/common/form';

import type { EmailTemplateData, UserWithBasicData } from 'shared-types';

interface Props {
  emailTemplates: EmailTemplateData[];
  emailTemplatesDefault: EmailTemplateData;
  updateUsers: () => Promise<void>;
  targetUser: UserWithBasicData;
}

const PathAccessUsersInviteSingle = ({
  emailTemplates,
  emailTemplatesDefault,
  targetUser,
  updateUsers
}: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { path }
  } = useReduxState();

  const handleSubmit = async (values) => {
    const data = {
      emailAddress: targetUser.email,
      emailContent: values.email
    };

    const response = await api.post(
      `/admin/paths/${path.id}/users-invite`,
      data
    );

    const errorEmails = Object.keys(response.data.errors);
    if (errorEmails && errorEmails.length) {
      dispatch.addNotice({
        text: `${messages.commonSendEmailInvitesError}<br />${errorEmails[0]}`,
        type: 'warning'
      });
      return false;
    }

    await updateUsers();

    dispatch.addNotice({
      text: messages.commonSendEmailInviteSuccess,
      type: 'success'
    });
  };

  if (!emailTemplatesDefault) return null;

  const initialValues = {
    email: {
      ...emailTemplatesDefault.email,
      selectedTemplateIdentifier: emailTemplatesDefault.identifier
    }
  };

  return (
    <ModalButtonWithForm
      buttonIcon="paper-plane"
      buttonSize="header"
      buttonText={messages.commonSendEmailInvite}
      initialValues={initialValues}
      modalActionText={messages.commonSend}
      modalTitle={messages.commonSendEmailInvite}
      modalWidth="wide"
      onSubmit={handleSubmit}
    >
      {() => (
        <div>
          <FormGroup label={messages.commonRecipient}>
            <User enableProfileLink={true} user={targetUser} />
          </FormGroup>

          <EmailMessageEditor
            availableTemplates={emailTemplates}
            id={`path-users-invite-single-${targetUser.id}`}
            style={{ marginTop: 20 }}
          />
        </div>
      )}
    </ModalButtonWithForm>
  );
};

export default PathAccessUsersInviteSingle;
